export enum CheckStateEnum {
  CHECK_ABSENT = 'CHECK_ABSENT',
  CHECK_VALIDATION_IN_PROGRESS  = 'CHECK_VALIDATION_IN_PROGRESS',
  CHECK_EXPIRED  = 'CHECK_EXPIRED',
  CHECK_CLOSED  = 'CHECK_CLOSED',
  CHECK_UNDEFINED = 'CHECK_UNDEFINED'
}
